const ROUTE_BASE = import.meta.env.VITE_API_BASE_URL;

const ROUTE_USER_SHOW = 'user';
const ROUTE_USER_UPDATE = 'user';

const ROUTE_LOGIN = 'auth/login';
const ROUTE_REGISTER = 'auth/register';
const ROUTE_AUTH_LOGOUT = 'auth/logout';

const ROUTE_VERSION = 'version';
const ROUTE_CONFIG = 'config';

const ROUTE_FILE_UPLOAD = 'file/upload';
const ROUTE_FILE_DOWNLOAD = 'file/download';

export {
  ROUTE_BASE,
  ROUTE_CONFIG,
  ROUTE_USER_SHOW,
  ROUTE_USER_UPDATE,
  ROUTE_VERSION,
  ROUTE_FILE_UPLOAD,
  ROUTE_FILE_DOWNLOAD,
  ROUTE_LOGIN,
  ROUTE_REGISTER,
  ROUTE_AUTH_LOGOUT,
};
